<script lang="ts">
  import type { IWikiBranch } from '../../../types'
  import { branches, selectedBranch } from '../../../store'
  import { changeWikiBranch } from '../../../services'
  import { getBranchSvg } from '../helpers'

  // Выпадающий список веток — копия Newsline/.../NewslineTabs/components/MobileTabs.svelte
  const isMobileApp: boolean = JSON.parse(localStorage.getItem('from_mobile')) === true

  let isShowMenu: boolean = false
  let y: number

  const changeOption = (option: IWikiBranch) => {
    isShowMenu = false

    changeWikiBranch(option)
  }
</script>

<svelte:window bind:scrollY={y} />

{#if $selectedBranch}
  <div 
    class="wrapper"
    style:top={
      y < 1
        ? !isMobileApp ? '142px' : '52px'
        : isMobileApp ? '0px' : '88px'
    }
    style:border-bottom={
      y > 1
        ? '1px solid #00000008'
        : 'none'
    }
  >
    <div class="w-100 px-4">
      <div 
        class="w-100 flex items-center justify-between" 
        on:click={() => isShowMenu = !isShowMenu}
      >
        <div class="flex items-center">
          <div 
            class="icon-wrapper"
            style:background={$selectedBranch.color + '1A'}
          >
            {@html getBranchSvg($selectedBranch.color)}
          </div>

          <div 
            style:color={$selectedBranch.color}
            class="title ml-sm"
          >
            {$selectedBranch.title}
          </div>  
        </div>

        <div 
          class="icon-wrapper rounded-full" 
          style:background={'#EFF1FD'}
        >
          {#if isShowMenu}
            <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.742536 5.22848C1.02629 4.86537 1.42582 4.37015 1.88748 3.84446C2.3468 3.32143 2.88184 2.75193 3.43643 2.24793C3.96469 1.76785 4.58524 1.27786 5.22821 0.970897C5.26426 0.952993 5.30127 0.936479 5.3392 0.921444C5.59614 0.818041 5.83911 0.798782 5.99918 0.800146C6.15926 0.798782 6.40222 0.818041 6.65917 0.921444C6.69709 0.936479 6.73411 0.952992 6.77016 0.970897C7.41313 1.27786 8.03367 1.76785 8.56194 2.24793C9.11653 2.75193 9.65157 3.32143 10.1109 3.84446C10.5725 4.37015 10.9721 4.86537 11.2558 5.22848C11.4556 5.48416 11.6876 5.7399 11.8369 6.0288C12.1622 6.65837 11.9888 7.44865 11.3982 7.87822C10.7537 8.34695 9.8281 8.19846 9.35905 7.55578C8.53662 6.43698 7.62837 5.34375 6.59882 4.40812C6.37811 4.20755 6.17709 4.04187 5.99918 3.91035C5.82127 4.04187 5.62025 4.20755 5.39955 4.40812C4.29061 5.4159 3.09027 6.95386 2.74067 7.41936C2.2345 8.09336 1.34339 8.41873 0.600179 7.87822C-0.0333598 7.41746 -0.187311 6.54236 0.239724 5.89509C0.401209 5.66838 0.571178 5.44777 0.742536 5.22848Z" fill="#576CED"/>
            </svg>  
          {:else}          
            <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.2555 3.72464C10.9718 4.08776 10.5722 4.58297 10.1106 5.10867C9.65125 5.63169 9.11621 6.20119 8.56162 6.70519C8.03335 7.18527 7.41281 7.67527 6.76984 7.98223C6.73379 8.00013 6.69677 8.01665 6.65885 8.03168C6.4019 8.13508 6.15894 8.15434 5.99886 8.15298C5.83879 8.15434 5.59582 8.13508 5.33888 8.03168C5.30095 8.01665 5.26394 8.00013 5.22789 7.98223C4.58492 7.67527 3.96437 7.18527 3.4361 6.70519C2.88151 6.20119 2.34648 5.63169 1.88716 5.10867C1.4255 4.58297 1.02597 4.08776 0.742216 3.72464C0.542425 3.46897 0.310404 3.21323 0.161124 2.92433C-0.16419 2.29476 0.00920201 1.50448 0.599859 1.07491C1.24437 0.606174 2.16994 0.754661 2.63899 1.39734C3.46143 2.51615 4.36967 3.60937 5.39923 4.54501C5.61993 4.74558 5.82095 4.91126 5.99886 5.04278C6.17677 4.91126 6.37779 4.74558 6.5985 4.54501C7.70744 3.53723 8.90778 1.99926 9.25738 1.53376C9.76355 0.859764 10.6547 0.534392 11.3979 1.07491C12.0314 1.53566 12.1854 2.41077 11.7583 3.05804C11.5968 3.28474 11.4269 3.50536 11.2555 3.72464Z" fill="#576CED"/>
            </svg> 
          {/if}         
        </div>
      </div>

      {#if isShowMenu}
        <div class="absolute mt-2 bg-white w-100 left-0">
          {#each $branches as item (item.pk)}
            <div 
              class="flex px-4 items-center justify-between py-3"
              style="border-bottom: 1px solid #00000014"
              style:color={item.color}
              on:click={() => changeOption(item)}
            >
              <div class="flex items-center">
                <div 
                  class="icon-wrapper"
                  style:background={item.color + '1A'}
                >
                  {@html getBranchSvg(item.color)}
                </div>

                <div class="ml-2 font-medium">{item.title}</div>
              </div>

              {#if item.pk === $selectedBranch.pk}
                <div>
                  <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.5639 6.88384C11.2801 7.24695 10.8806 7.74218 10.4189 8.26787C9.95961 8.7909 9.42457 9.36039 8.86998 9.86439C8.34171 10.3445 7.72117 10.8345 7.07821 11.1414C7.04215 11.1593 7.00514 11.1758 6.96721 11.1909C6.71027 11.2943 6.4673 11.3135 6.30723 11.3122C6.14716 11.3135 5.90419 11.2943 5.64724 11.1909C5.60932 11.1758 5.5723 11.1593 5.53625 11.1414C4.89329 10.8345 4.27274 10.3445 3.74447 9.86439C3.18988 9.36039 2.65484 8.7909 2.19553 8.26787C1.73387 7.74218 1.33433 7.24695 1.05058 6.88384C0.850788 6.62817 0.761122 6.63881 0.611843 6.34992C0.286528 5.72034 0.459922 4.93006 1.05058 4.50049C1.69509 4.03176 2.62066 4.18024 3.08972 4.82292C3.91215 5.94173 4.67804 6.76857 5.7076 7.7042C5.9283 7.90477 6.12932 8.07046 6.30723 8.20198C6.48514 8.07046 6.68616 7.90477 6.90686 7.7042C8.0158 6.69642 11.9088 1.88434 12.2584 1.41884C12.7645 0.744844 13.6556 0.419472 14.3988 0.959987C15.0324 1.42074 15.1863 2.29585 14.7593 2.94312C14.5978 3.16982 11.7352 6.66455 11.5639 6.88384Z" fill="#576CED"/>
                  </svg>                  
                </div>
              {/if}
            </div>
          {/each}
        </div>
      {/if}
    </div>
  </div>
{/if}

<style lang="scss">
  .wrapper {
    z-index: 9999;
    width: 100%;
    left: 0;
    min-height: 44px;
    background-color: white;
    position: fixed;
    display: flex;
    align-items: center;
  }

  .icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 28px;
    height: 28px;
    border-radius: 8px;
  }

  .title {
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
  }
</style>